module.exports = __webpack_public_path__ + "static/media/zip_preview.1362bd54.svg";